module.exports = __webpack_public_path__ + "img/901244984.da254890.png";